import { $dayjs, Dayjs } from '../$dayjs'

const DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
const DATEONLY_FORMAT = 'YYYY-MM-DD'
const TIME_FORMAT = 'HH:mm:ss'

const DATE_COLUMN_TYPES = new Set(['DATETIME', 'DATEONLY', 'TIME', 'ITME'])

const isPlainEmptyObject = (val: unknown): boolean =>
  !!val &&
  typeof val === 'object' &&
  !Array.isArray(val) &&
  !(val instanceof Date) &&
  Object.keys(val).length === 0 &&
  val.constructor === Object

export const isDayjsLike = (val: unknown): val is Dayjs =>
  !!val &&
  typeof val === 'object' &&
  '$d' in (val as object) &&
  typeof (val as Dayjs).format === 'function'

const formatForColumnType = (columnType: string | undefined): string => {
  if (columnType === 'DATEONLY') {
    return DATEONLY_FORMAT
  }
  if (columnType === 'TIME' || columnType === 'ITME') {
    return TIME_FORMAT
  }
  return DATETIME_FORMAT
}

export const isDateColumnType = (columnType: string | undefined): boolean =>
  !!columnType && DATE_COLUMN_TYPES.has(columnType)

/**
 * DATETIME / DATEONLY / TIME 列向けに保存前の値を正規化する。
 * - Date / dayjs → format 文字列
 * - 空 object / Invalid Date → null
 * - 既存 string → そのまま
 */
export const normalizeDateColumnValueForSave = (
  val: unknown,
  columnType: string | undefined,
): unknown => {
  if (val === null || val === undefined) {
    return val
  }
  if (isPlainEmptyObject(val)) {
    return null
  }
  if (typeof val === 'string') {
    return val
  }

  const format = formatForColumnType(columnType)

  if (val instanceof Date) {
    if (Number.isNaN(val.getTime())) {
      return null
    }
    return $dayjs(val).format(format)
  }

  if (isDayjsLike(val)) {
    if (!val.isValid()) {
      return null
    }
    return val.format(format)
  }

  return val
}

/**
 * removeUndefinedValuedKey 用: 列型不明の Date / dayjs を DATETIME 形式文字列へ。
 */
export const serializeDateLikeValueForSave = (val: Date | Dayjs): string | null => {
  if (val instanceof Date) {
    if (Number.isNaN(val.getTime())) {
      return null
    }
    return $dayjs(val).format(DATETIME_FORMAT)
  }
  if (!val.isValid()) {
    return null
  }
  return val.format(DATETIME_FORMAT)
}
